require('./collapsableMenuController');
require('./collapsableMenuService');

"use strict";

angular.module('app.mainFrame.collapsableMenu.collapsableMenuDirective', [
    'app.mainFrame.collapsableMenuController',
    'app.mainFrame.collapsableMenu.collapsableMenuService'
])
    .directive('collapsableMenu', [
        '$document',
        'app.mainFrame.collapsableMenu.collapsableMenuService',
        function ($document, collapsableMenu) {
            return {
                restrict: 'AE',
                templateUrl: 'components/mainFrame/collapsableMenu/collapsableMenuView.html',
                controller: 'app.mainFrame.collapsableMenuController',
                link: function (scope, elm) {
                    scope.$watch(
                        function () {
                            return collapsableMenu.menuExpanded;
                        },
                        function () {
                            if (collapsableMenu.menuExpanded) {
                                elm.addClass('open');
                            }
                            else {
                                elm.removeClass('open');
                            }
                        }
                    );
                }
            };
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/mainFrame/collapsableMenu/collapsableMenuDirective.js